import React, { useState, useEffect } from "react";
import news from "../../Json/news.json";
import { Link } from "react-router-dom";
import "./NewsSlider.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const DEFAULT_IMAGE =
	"https://res.cloudinary.com/atlasendurhaefing/image/upload/v1692272978/atlas2.0/frettir/newsDefault_idazwm.jpg";

/* How many fit on one row. The row never wraps — anything that does not fit
   is left out rather than pushed onto a second line. */
const BREAKPOINTS = [
	{ query: "(min-width: 1200px)", columns: 4, items: 4 },
	{ query: "(min-width: 900px)", columns: 3, items: 3 },
];

/* Below three columns the cards stack as compact rows instead — two cards
   side by side reads worse than a short list. */
const NARROW = { columns: 1, items: 3 };

function layoutThatFits() {
	const match = BREAKPOINTS.find((point) => window.matchMedia(point.query).matches);
	return match || NARROW;
}

function NewsDisplay() {
	const [layout, setLayout] = useState(layoutThatFits);

	useEffect(() => {
		const update = () => setLayout(layoutThatFits());
		window.addEventListener("resize", update);
		return () => window.removeEventListener("resize", update);
	}, []);

	const frontPageNews = news
		.filter((thisNews) => thisNews.frontPage)
		.slice(0, layout.items);

	if (frontPageNews.length === 0) {
		return null;
	}

	return (
		<div
			className="allNews"
			style={{
				gridTemplateColumns: `repeat(${Math.min(
					layout.columns,
					frontPageNews.length
				)}, minmax(0, 1fr))`,
			}}
		>
			{frontPageNews.map((thisNews) => (
				<Link
					to={`/frettir/${thisNews.id}`}
					key={thisNews.id}
					className="newsLink"
				>
					<LazyLoadImage
						src={thisNews.image || DEFAULT_IMAGE}
						alt={thisNews.title}
						className="frontNewsImage"
						effect="blur"
					/>
					<div className="frontNewsText">
						<h3 className="frontNewsTitle">{thisNews.title}</h3>
						<p className="frontNewsDate">{thisNews.date}</p>
						<p className="frontNewsDescription">{thisNews.description}</p>
					</div>
				</Link>
			))}
		</div>
	);
}

export default NewsDisplay;
